import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// CSS
import "../../../css/training/training-menu.css";

// Utils
import {
	videoHasBeenWatched,
	getVideoIdFromUri,
	showWatchedBar
} from "../../../utils/training/videos";

class VideoItem extends Component {
	truncateString = (string, max) => {
		if (string.length <= max) return string;

		// Return string minus 4 chars and an ellipse
		return string.substr(0, max - 4) + " ...";
	};

	render() {
		const { translations, video, footer, user, videoSurveys } = this.props;
		const videoId = getVideoIdFromUri(video);

		return (
			<div
				className={
					`training-menu--item` +
					(videoHasBeenWatched(videoId, user).length ? ` training-menu--item-active` : ``)
				}
			>
				<div
					className="training-item--icon-wrapper"
					style={{ backgroundImage: `url(${video.pictures.sizes[2].link})` }}
				/>
				<div className="training-item--text">
					<h2>{this.truncateString(video.name, 40)}</h2>
					{video.description && <div className="txt">{video.description}</div>}
				</div>
				{showWatchedBar(video, user, videoSurveys, translations)}
				{!!footer && (
					<Link className="training-item--footer" to={`/training/videos/${videoId}`}>
						{footer}
					</Link>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		user: state.user.reviewer.user,
		videoSurveys: state.trainingVideos.videoSurveys
	};
};

export default connect(mapStateToProps)(VideoItem);



// WEBPACK FOOTER //
// ./src/components/training/videos/VideoItem.js